import { GetSenderDetailsResponse } from "@/types/api/senderDetails";

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

function prepareForEdit(details: GetSenderDetailsResponse) {
  return (
    Object.entries(details) as Entries<GetSenderDetailsResponse>
  ).reduce<GetSenderDetailsResponse>(
    (acc: any, [key, value]: any) => {
      if (typeof value === "string" && value === "Not indicated") {
        acc[key] = "";
      }
      return acc;
    },
    { ...details }
  );
}

function prepareForUpdate(details: GetSenderDetailsResponse) {
  return (
    Object.entries(details) as Entries<GetSenderDetailsResponse>
  ).reduce<GetSenderDetailsResponse>(
    (acc: any, [key, value]: any) => {
      if (typeof value === "string" && value === "") {
        acc[key] = "Not indicated";
      }
      return acc;
    },
    { ...details }
  );
}

function isFreeDomain(email: string): boolean {
  const domain = email.split("@").pop()?.toLowerCase() || "";
  const patterns = [
    /^(outlook|live|hotmail|msn)\.(com|net|co\.[a-z]{2}|com\.[a-z]{2}|[a-z]{2})$/,
    /^.\.onmicrosoft\.com$/,
    /^(gmail|googlemail)\.com$/,
    /^(yahoo|ymail|rocketmail|aol|aim|frontier|frontiernet|compuserve|verizon)\.(com|net|co\.[a-z]{2}|com\.[a-z]{2}|[a-z]{2})$/,
    /^(icloud|me|mac)\.com$/,
    /^proton(mail)?\..$/,
    /^[a-zA-Z0-9.-]\.edu$/,
    /^[a-zA-Z0-9.-]\.gov$/,
    /^[a-zA-Z0-9.-]\.mil$/,
    /^(comcast|xfinity|cable\.comcast)\.(net|com)$/,
    /^(att|sbcglobal|bellsouth|currently|flash|nvbell|pacbell|prodigy|snet|swbell|wans|worldnet\.att|ameritech)\.(net|com)$/,
    /^(cox|charter|spectrum|earthlink)\.net$/,
    /^(tutanota|protonmail|hushmail|mailfence|startmail|countermail|ctemplar)\.com$/,
    /^(zoho|fastmail)\.com$/,
    /^(qq|163|126|sina|sohu|naver|daum|line)\.(com|me)$/,
    /^(orange|sfr|free|libero|web|arcor|tiscali|ziggo|swisscom|sunrise|telekom)\..$/,
    /^(lycos|excite|netzero)\.com$/,
    /^(bt|o2|kpn|telstra|vodafone|rogers|telus|shaw)\..*$/,
    /^(mail|inbox|email)\.com$/,
  ];
  return patterns.some((pattern) => pattern.test(domain));
}

export { prepareForEdit, prepareForUpdate, isFreeDomain };
